import React from 'react';
import Navbar from "../../components/base/Navbar";
import EmailTable from "../components/EmailTable";
import Footer from "../../components/base/Footer";


const EmailPanel = () => {
    return (
        <div className="bg-gray-200 pt-24 bg-center">

            <Navbar/>

            <div className="mb-48">
                <div className="w-full "></div>

                <h1 className="text-3xl">Admin Panel - Email Subscription</h1>

                <a className="absolute cursor-pointer right-32 top-28 bg-blue-500 rounded-lg py-2 px-5 text-white hover:ring-2"
                   href="/admin">Zurück</a>

                <div className="w-full m-12"></div>

                <EmailTable/>

                <div className="w-full m-12"></div>
            </div>

            <Footer/>
        </div>
    );
}

export default EmailPanel;